import gql from "graphql-tag";


export const POINT_RATE = gql`
  query pointRate {
    shop {
      pointRatioForOrder
    }
  }
`;